import { temAcesso } from '@/shared/auth/temAcesso'

const MensagensPainel = () => import('./MensagensPainel.vue')
const Mensagem = () => import('./Mensagem.vue')

export default {
    path: 'mensagens',
    name: 'Mensagens',
    component: MensagensPainel,
    beforeEnter: (to, from, next) => {
        if (temAcesso('MENSAGENS-00')) {
            next()
        }
    },
    children: [
        {
            path: 'nova',
            name: 'Mensagens_Inserir',
            component: Mensagem,
            beforeEnter: (to, from, next) => {
                if (temAcesso('MENSAGENS-00')) {
                    next()
                }
            }
        },
        {
            path: ':mensagemId',
            name: 'Mensagens_Detalhar',
            component: Mensagem,
            beforeEnter: (to, from, next) => {
                if (temAcesso('MENSAGENS-00')) {
                    next()
                }
            }
        }
    ]
}
